module.exports = "<section>\n    <section head></section>\n    <div class=\"tablesection\">\n        <div class=\"tablecontainer col-md-12 col-lg-11\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/applications/http_by_domain_uri.html
 ** module id = 591
 ** module chunks = 0
 **/